'use client'

import React, { forwardRef } from 'react'
import s from './Input.module.scss'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  className?: string
  helperText?: string
  onHelperClick?: () => void
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { label, error, className = '', helperText, onHelperClick, ...props },
    ref
  ) => {
    return (
      <div className={s.inputGroup}>
        {label && (
          <label className={s.label}>
            {label}
            {props.required && ' *'}
          </label>
        )}
        <input
          ref={ref}
          className={`${s.input} ${error ? s.error : ''} ${className}`}
          {...props}
        />
        {error && <span className={s.errorText}>{error}</span>}
        {helperText && !error && (
          <span
            className={`${s.helperText} ${onHelperClick ? s.clickable : ''}`}
            onClick={onHelperClick}
          >
            {helperText}
          </span>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'
